import { Component, QueryList, ViewChildren } from '@angular/core';
import { DataService } from './../../../services/data/data.service';
import { environment } from './../../../../environments/environment'
import { CuentaEntity, EvaluacionEntity, Detalle_Evaluacion_CuentaEntity } from './../../funciones/AlertaTemprana';
import { getEvaluaciones, getDetalleEvaluacionCuenta, getCuentas, getDetalleEvaluacionVarTemp, getVarsTemp, getDetalleEvaluacionVars, getVars } from './../../../services/financiero/estados-resultados/querys';
import { obtenerCodigoPropio, ObtenerIds } from './../idsTablas'
import Swal from 'sweetalert2';
import { Apollo } from 'apollo-angular';
import { firstValueFrom } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ExcelService } from '../../../services/excel/excel.service';
import { IMG } from '../../../services/imagen/png';
import { formatear, periodos } from '../../funciones/funcionesGenerales';
import { messages } from '../../funciones/mensajes';
import { FiltersM, typesApex } from '../../../components/models';
import { companiesFinanciero } from '../../../shared/catalogos';
import { GraficadorComponent } from '../../../components/graficador/graficador.component';

@Component({
  selector: 'app-estados-financieros',
  templateUrl: './estados-financieros.component.html',
  styleUrl: './estados-financieros.component.css'
})
export class EstadosFinancierosComponent {
  public Filters = FiltersM;
  @ViewChildren(GraficadorComponent) graficador!: QueryList<GraficadorComponent>;
  private headers = new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('token'));

  public suffix = 'Gs';
  public miles = ',';
  public decimal = '.';
  
  public subTitles = [];
  public cadenaEvaluacion = [];
  public perspectives = [
    {name: 'Horizontal', check: false},
    {name: 'Vertical', check: false},
  ]
  public cadenaEvaluacionHorizontal = [];
  public dataOrdenadoBalance = [];
  public dataOrdenadoEstados = [];
  private dataSaldos = [];
  private dataCuentas = [];
  public Periodos = [];
  public PeriodosOri = [];
  public tituloTabla = '';
  public balanceEstados = true;
  public analisisVertical = false;
  public analisisHorizontal = false;
  private maxPeriodos = 4;
  private periodosSeleccionados = 0;
  /* Graficas */
  //Titulos y subtitulos
  public titulo1 = '';
  public subTitulo1 = '';
  public titulo2 = '';
  public subTitulo2 = '';
  public titulo3 = '';
  public subTitulo3 = '';
  public titulo1Res = '';
  public subTitulo1Res = '';
  //Graficas ampliar
  public graf1 = false;
  public graf2 = false;
  public graf3 = false;
  public graf4 = false;

  public filtroAct1 = false;
  private titOrig1 = ''; 
  public filtroAct2 = false;
  private titOrig2 = '';
  public filtroAct3 = false;
  private titOrig3 = '';
  public filtroAct1Res = false;
  private titOrig1Res = '';
  public etiquetas1 = [];
  public etiquetas2 = [];
  public etiquetas3 = [];
  public etiquetas4 = [];
  public data1 = [];
  public data2 = [];
  public data3 = [];
  public data4 = [];
  public typeGraph = typesApex;
  public tipo1 = this.typeGraph.DONUT;
  public tipo2 = this.typeGraph.LINE;
  public tipo3 = this.typeGraph.BAR;
  public tipo4 = this.typeGraph.BARHORIZONTAL;
  // Grafica
  public colorMulti: any = ['#2843A0','#15A075','#36CAE8','#78EAD2','#F88476','#E23E6A'];
  public colorMono: any = ['#007298','#008FBE','#3BB0C9','#76C4D5','#8AD2E6','#C3E6F3'];
  public showLabels1: boolean = false;
  public showLabels2: boolean = false;
  public showLabels3: boolean = false;
  public showLabels4: boolean = false;  
  public xAxisLabel = 'Cuenta';
  public yAxisLabel = ['Saldo'];

  private cuentaEntity = new CuentaEntity;
  private evaluacionEntity = new EvaluacionEntity;
  private detalleCuentasEvaluacion = new Detalle_Evaluacion_CuentaEntity;
  public modalOpen: boolean = false;
  //Variables de personalizacion
  public multiMoneda: boolean;
  public codigoPropio: boolean;
  public monedaSelec: string = '';
  ngOnInit(): void {}

  constructor(
    public dataService: DataService,
    private apollo: Apollo,
    private translate: TranslateService,
    private cookieService: CookieService,
    private excelService: ExcelService,
  ) {
    this.cuentaEntity = new CuentaEntity;
    this.evaluacionEntity = new EvaluacionEntity;
    this.evaluacionEntity.Id_Plantilla = Number(cookieService.get('idPlanFin'));
    this.evaluacionEntity.Id_Institucion = Number(cookieService.get('idInstitucion'));
    this.cuentaEntity.Id_Plantilla = Number(cookieService.get('idPlanFin'));
    this.personalizacion();
    this.getEvaluacion();
  }
  private personalizacion(){
    const settings = companiesFinanciero.find(i => i.id == this.evaluacionEntity.Id_Institucion+'');
    this.multiMoneda = settings.multiMoneda;
    this.codigoPropio = settings.codigoPropio;
  }
  /* Consultas */
  private async getEvaluacion(){
    try{
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getEvaluaciones,
          context: { headers: this.headers, },
          variables: { idPlantilla: this.cuentaEntity.Id_Plantilla }
        }).valueChanges.source
      );

      var aux = [];
      for(const per of data.evaluaciones){
        if(per.idInstitucion === this.evaluacionEntity.Id_Institucion){
          aux.push(per);
        }
      }
      this.ordenamientoDataEvaluacion(aux);
    }catch(err){
      messages.errorMessageGraph(this.translate.instant(err));
    }
  }
  private async getDetalleEvaluacion(){
    try{
      let datos = [];
      for(const eva of this.cadenaEvaluacion){
        const { data } = await firstValueFrom(
          this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
            query: getDetalleEvaluacionCuenta,
            context: { headers: this.headers, },
            variables: { idEvaluacion: eva.id}
          }).valueChanges.source
        );
        datos = datos.concat(data.detalleEvaluacionCuentas)
          
      }
      this.getCuentas(datos);
    }catch(err){
      messages.errorMessageGraph(this.translate.instant(err));
    }
  }
  private async getCuentas(array){
    try{
      const { data }  = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getCuentas,
          context: { headers: this.headers, },
          variables: { idPlantilla: this.cuentaEntity.Id_Plantilla}
        }).valueChanges.source
      );

      let datos = data.cuentas;
      var aux = [], i =0;
      for(const data of array){
        for(const d of datos){
          if(data['idCuenta'] == d['id']){
            aux.push({
              descripcion: d.descripcion,
              idCuenta: data.idCuenta,
              idEvaluacion: data.idEvaluacion,
              valor: data.valor,
            });
            aux[i].cuentaEntity = d;
          }
        }
        i++;
      }
      array = aux;
      this.getDetalleEvaluacionVar(datos, array)
    }catch(err){
      messages.errorMessageGraph(this.translate.instant(err));
    }
  }
  private async getDetalleEvaluacionVar(cuent, evaCuent){
    try{
      let datos = [];
      for(const eva of this.cadenaEvaluacion){
        const { data } = await firstValueFrom(
          this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
            query: getDetalleEvaluacionVars,
            context: { headers: this.headers, },
            variables: { idEvaluacion: eva.id}
          }).valueChanges.source
        );
        datos = datos.concat(data.detalleEvaluacionVariables)
      }
      this.getVars(datos, cuent, evaCuent);
    }catch(err){
      messages.errorMessageGraph(this.translate.instant(err));
    }
  }
  private async getVars(array, cuent, evaCuent){
    try{
      const { data }  = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getVars,
          context: { headers: this.headers, },
          variables: { idPlantilla: this.cuentaEntity.Id_Plantilla}
        }).valueChanges.source
      );
      let datos = data.variables;
      var aux = [], i =0;
      for(const data of array){
        for(const d of datos){
          if(data['idVariable'] == d['id']){
            aux.push({
              descripcion: d.descripcion,
              idCuenta: data.idVariable,
              idEvaluacion: data.idEvaluacion,
              valor: data.valor,
            });
            aux[i].cuentaEntity = d;
          }
        }
        i++;
        }
        array = aux;
        array = array.concat(evaCuent);
        datos = datos.concat(cuent);
        this.getDetalleEvaluacionVarTem(datos, array);
    }catch(err){
      messages.errorMessageGraph(this.translate.instant(err));
    }
  }
  private async getDetalleEvaluacionVarTem(cuent, evaCuent){
    try{
      let datos = [];
      for(const eva of this.cadenaEvaluacion){
        const { data } = await firstValueFrom(
          this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
            query: getDetalleEvaluacionVarTemp,
            context: { headers: this.headers, },
            variables: { idEvaluacion: eva.id}
          }).valueChanges.source
        );

        datos = datos.concat(data.detalleEvaluacionVarsTemps)
      }
      this.getVarsTems(datos, cuent, evaCuent);
    }catch(err){
      messages.errorMessageGraph(this.translate.instant(err));
    }
  }
  private async getVarsTems(array, cuent, evaCuent){
    // try{
      const { data }  = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getVarsTemp,
          context: { headers: this.headers, },
          variables: { idPlantilla: this.cuentaEntity.Id_Plantilla}
        }).valueChanges.source
      );
      let datos = data.varsTemp;
      var aux = [], i =0;
      for(const data of array){
        for(const d of datos){
          if(data['idVarTemp'] == d['id']){
            aux.push({
              descripcion: d.descripcion,
              idCuenta: data.idVarTemp,
              idEvaluacion: data.idEvaluacion,
              valor: data.valor,
            });
            aux[i].cuentaEntity = d;
          }
        }
        i++;
      }
      array = aux;
      
      this.dataCuentas = array.concat(evaCuent);
      this.dataSaldos = datos.concat(cuent);
      this.obtDataOrdenado(this.dataSaldos, this.dataCuentas);
    // }catch(err){
    //   messages.errorMessageGraph(this.translate.instant(err));
    // }
  }
  /* Obtención de datos */
  private ordenamientoDataEvaluacion(datos){
    this.tituloTabla = 'financiero.catalogoCuentas.tituloTabla1';
    const info = periodos.obtenerPeriodos(datos, this.maxPeriodos);
    this.Periodos = info.periodos;
    this.PeriodosOri = info.periodos;
    for(const an of this.Periodos){
      if(an.anio < 2023){
        an.utilizable = false;
      }
    }
    this.ultimasEvaluaciones();
  }
  private obtDataOrdenado(data, dataAll){
    this.dataOrdenadoBalance = [];
    this.dataOrdenadoEstados = [];
    var arrayElemetos = [];
    for(const acount of data){
      this.acomodarElementosBalanceGen(acount, dataAll, arrayElemetos);
      this.acomodarElementosEstadosResultados(acount, dataAll, arrayElemetos);
    }

    this.ordenarArreglos();
    this.buscarFaltantes()
    this.obtDataGraf1();
    this.obtDataGraf2();
    this.obtDataGraf3();
    this.obtDataGrafRes();
  }
  private acomodarElementosBalanceGen(acount, dataAll, arrayElemetos){
    var plantilla = '';
    if(this.cuentaEntity.Id_Plantilla === 5){
      plantilla = 'idsCuentasP5'
    }else if(this.cuentaEntity.Id_Plantilla === 7){
      plantilla = 'idsCuentasP7'
    }else if(this.cuentaEntity.Id_Plantilla === 9){
      plantilla = 'idsCuentasP9'
    }else if(this.cuentaEntity.Id_Plantilla === 8){
      plantilla = 'idsCuentasP8'
    }else if(this.cuentaEntity.Id_Plantilla === 12){
      plantilla = 'idsCuentasP12'
    }else if(this.cuentaEntity.Id_Plantilla === 13){
      plantilla = 'idsCuentasP13'
    }
    for(const period of this.cadenaEvaluacion){
      if(ObtenerIds[plantilla](acount.id, `bal${this.monedaSelec}`) !== undefined){
        const datos = dataAll.filter(
          dat => {
            return period.id === dat.idEvaluacion && acount.id === dat.idCuenta && this.cuentaEntity.Id_Plantilla === dat.cuentaEntity.idPlantilla
          }
        );
        arrayElemetos = arrayElemetos.concat(datos);
      }
    }

    let analisisH = [], evaHori = [];
    for( var i = 0; i < this.cadenaEvaluacion.length-1;i++){
      analisisH.push({"evaten":this.cadenaEvaluacion[i].evaluacion + " vs " + this.cadenaEvaluacion[i+1].evaluacion,"PorcentajeH":this.cadenaEvaluacion[i].evaluacion,"porcentajeHor":"%"});
    }
    this.cadenaEvaluacionHorizontal = analisisH;
    let diferencia  = 0;
    let division = 1;

    for(var i = 0; i < arrayElemetos.length-1;i++){
      diferencia = arrayElemetos[i+1].valor-arrayElemetos[i].valor;
      if(arrayElemetos[i].valor == 0)
        division = 0;
      else
        division = diferencia/arrayElemetos[i].valor*100;
      evaHori.push({"evaluacionHorizontal":diferencia,"porcentajeValorH":division});
    }
    if(arrayElemetos.length !== 0){
      var config = obtenerCodigoPropio.idsCodigoPropio(this.evaluacionEntity.Id_Plantilla, acount.id);      
      this.dataOrdenadoBalance.push({
        "id":arrayElemetos[arrayElemetos.length-1].idCuenta,
        "codigo": config?.codigo,
        "idCuenta":acount.id,
        "Descripcion":this.capitalizacionTexto(acount.descripcion),
        "posicion": ObtenerIds[plantilla](acount.id, `bal${this.monedaSelec}`)[0].pos, 
        "Nivel": ObtenerIds[plantilla](acount.id, `bal${this.monedaSelec}`)[0].nivel,
        "Check": ObtenerIds[plantilla](acount.id, `bal${this.monedaSelec}`)[0].nivel===1||ObtenerIds[plantilla](acount.id, `bal${this.monedaSelec}`)[0].nivel===2?true:false,
        "dbCheck":ObtenerIds[plantilla](acount.id, `bal${this.monedaSelec}`)[0].nivel===1?true:false,
        "Series": arrayElemetos,
        "evaluacionHorizontal": evaHori,
      });
    }
    arrayElemetos = [];
  }
  private acomodarElementosEstadosResultados(acount, dataAll, arrayElemetos){
    var plantilla = '';
    if(this.cuentaEntity.Id_Plantilla === 5){
      plantilla = 'idsCuentasP5'
    }else if(this.cuentaEntity.Id_Plantilla === 7){
      plantilla = 'idsCuentasP7'
    }else if(this.cuentaEntity.Id_Plantilla === 9){
      plantilla = 'idsCuentasP9'
    }else if(this.cuentaEntity.Id_Plantilla === 8){
      plantilla = 'idsCuentasP8'
    }else if(this.cuentaEntity.Id_Plantilla === 12){
      plantilla = 'idsCuentasP12'
    }else if(this.cuentaEntity.Id_Plantilla === 13){
      plantilla = 'idsCuentasP13'
    }
    for(const period of this.cadenaEvaluacion){
      if(ObtenerIds[plantilla](acount.id, `est${this.monedaSelec}`) !== undefined){
        const datos = dataAll.filter(
          dat => {
            return period.id === dat.idEvaluacion && acount.id === dat.idCuenta && this.cuentaEntity.Id_Plantilla === dat.cuentaEntity.idPlantilla
          }
        );
        arrayElemetos = arrayElemetos.concat(datos);
      }
    }

    let analisisH = [], evaHori = [];
    for( var i = 0; i < this.cadenaEvaluacion.length-1;i++){
      analisisH.push({"evaten":this.cadenaEvaluacion[i].evaluacion + " vs " + this.cadenaEvaluacion[i+1].evaluacion,"PorcentajeH":this.cadenaEvaluacion[i].evaluacion,"porcentajeHor":"%"});
    }
    this.cadenaEvaluacionHorizontal = analisisH;
    let diferencia  = 0;
    let division = 1;
    for(var i = 0; i < arrayElemetos.length-1;i++){
      diferencia = arrayElemetos[i+1].valor-arrayElemetos[i].valor;
      if(arrayElemetos[i].valor == 0)
        division = 0;
      else
        division = diferencia/arrayElemetos[i].valor*100;
      evaHori.push({"evaluacionHorizontal":diferencia,"porcentajeValorH":division});
    }

    if(arrayElemetos.length !== 0){
      var config = obtenerCodigoPropio.idsCodigoPropio(this.evaluacionEntity.Id_Plantilla, acount.id);
      this.dataOrdenadoEstados.push({
        "id":arrayElemetos[arrayElemetos.length-1].idCuenta,
        "codigo": config?.codigo,
        "idCuenta":acount.id,
        "Descripcion":acount.descripcion,
        "posicion": ObtenerIds[plantilla](acount.id, `est${this.monedaSelec}`)[0].pos, 
        "Nivel": ObtenerIds[plantilla](acount.id, `est${this.monedaSelec}`)[0].nivel,
        "Check": ObtenerIds[plantilla](acount.id, `est${this.monedaSelec}`)[0].nivel===1||ObtenerIds[plantilla](acount.id, `est${this.monedaSelec}`)[0].nivel===2?true:false,
        "dbCheck":ObtenerIds[plantilla](acount.id, `est${this.monedaSelec}`)[0].nivel===1?true:false,
        "Series": arrayElemetos,
        "evaluacionHorizontal": evaHori,
      });
    }
    arrayElemetos = [];
  }
  public porcentajeEvaluacionVertical(array,monto,index,ind){
    let nivel = array[ind].Nivel;
    let monto2 = 0;
    if(nivel !== 1 && nivel !== 2 && this.cuentaEntity.Id_Plantilla !== 12){
      for(var i = ind; i >= 0; i--){
        if(array[i].Nivel < nivel){
          monto2 = array[i].Series[index].valor;
          break;
        }else if(i === 0){
          monto2 = array[i].Series[index].valor;
        }
      }
    }else{
      monto2 = array[0].Series[index].valor;
    }
    if(monto2 === 0 && monto === 0){
      return 0;
    }
    if(monto2 === 0){
      return 0;
    }
    const n = !Number.isNaN((monto/monto2)*100) ? (monto/monto2)*100 : 0;
    return n;
  }
  /* data ordenados */
  private obtDataGrafRes(){
    this.subTitulo1Res = this.cadenaEvaluacion[this.cadenaEvaluacion.length-1].evaluacion;
    const id = this.cadenaEvaluacion[this.cadenaEvaluacion.length-1].id;
    var aux = [], pos = 0;
    for(const dat of this.dataOrdenadoEstados){
      if(dat.Nivel === 2){
        this.titulo1Res = dat.Descripcion;
        var aux2 = this.obtDataSubnivel(dat, this.dataOrdenadoEstados, pos, id);
        const dato = dat.Series.filter(eva => eva.idEvaluacion === id);
        if(dato.length !== 0){
          aux.push({
            descripcion: dato[0].descripcion,
            idCuenta: dato[0].idCuenta,
            idEvaluacion: dato[0].idEvaluacion,
            valor: dato[0 ].valor,
            Series: aux2,
          });
        }
      }
      pos++;
    }
    this.data4 = [];
    this.etiquetas4 = [];
    var cantidades = [], extra = [];
    for(const dato of aux){
      this.etiquetas4.push(dato.descripcion);
      cantidades.push(dato.valor)
      extra.push(dato.Series)
    }
    this.data4.push({
      name: 'a',
      data: cantidades,
      extra: extra
    })
    this.titOrig1Res = this.titulo1Res;
  }
  public selectGrafRes(data){
    const base = this.data4[0].extra[data.posValue];
    if(base.length !== 0){
      this.data4 = [];
      this.etiquetas4 = [];
      var cantidades = [], extra = [];
      for(const dato of base){
        this.etiquetas4.push(dato.descripcion);
        cantidades.push(dato.valor)
        extra.push(dato.Series)
      }
      this.data4.push({
        name: 'a',
        data: cantidades,
        extra: extra
      });
      this.filtroAct1Res = true;
    }else{
      messages.infoMessageGraph(this.translate.instant('financiero.catalogoCuentas.swal1'));
    }
  }
  public borrarFiltrosRes(){
    this.titulo1Res = this.titOrig1Res;
    this.obtDataGrafRes();
    this.filtroAct1Res = false;
  }
  /* Datos graficas */
  private obtDataSubnivel(item, data ,pos, id){
    var aux = [];
    for( var i = pos+1; i<data.length; i++ ){
      if(data[i].Nivel === item.Nivel+1){
        const dato = data[i].Series.filter(eva => eva.idEvaluacion === id);
        if(dato.length !== 0){
          aux.push({
            descripcion: dato[0].descripcion,
            idCuenta: dato[0].idCuenta,
            idEvaluacion: dato[0].idEvaluacion,
            valor: dato[0 ].valor,
            Series: this.obtDataSubnivel(data[i], data, i, id),
          });
        }
      }
      if(data[i].Nivel === item.Nivel || data[i].Nivel < item.Nivel){
        break;
      }
    }
    if(aux.length !== 0)
      return aux;
    return [];
  }
  private obtDataGraf1(){
    this.subTitulo1 = this.cadenaEvaluacion[this.cadenaEvaluacion.length-1].evaluacion;
    const id = this.cadenaEvaluacion[this.cadenaEvaluacion.length-1].id;
    var aux = [], i = 0, pos = 0;
    for(const dat of this.dataOrdenadoBalance){
      if(i===0 && dat.Nivel === 1){
        this.titulo1 = dat.Descripcion;
        aux = this.obtDataSubnivel(dat, this.dataOrdenadoBalance, pos, id);
        i++;
      }
      pos++;
    }
    this.data1 = [];
    this.etiquetas1 = [];
    var cantidades = [], extra = [];
    for(const dato of aux){
      this.etiquetas1.push(dato.descripcion);
      cantidades.push(dato.valor)
      extra.push(dato.Series)
    }
    this.data1.push({
      name: 'a',
      data: cantidades,
      extra: extra
    })    
    this.titOrig1 = this.titulo1;
  }
  private obtDataGraf2(){
    this.subTitulo2 = this.cadenaEvaluacion[this.cadenaEvaluacion.length-1].evaluacion;
    const id = this.cadenaEvaluacion[this.cadenaEvaluacion.length-1].id;
    var aux = [], i = 0, pos = 0;
    for(const dat of this.dataOrdenadoBalance){
        this.titulo3 = dat.Descripcion;
      if(i===1 && dat.Nivel === 1){
        this.titulo2 = dat.Descripcion;
        aux = this.obtDataSubnivel(dat, this.dataOrdenadoBalance, pos, id);
        i++;
      }else if(dat.Nivel===1){
        i++
      }
      pos++;
    }
    this.data2 = [];
    this.etiquetas2 = [];
    var cantidades = [], extra = [];
    for(const dato of aux){
      this.etiquetas2.push(dato.descripcion);
      cantidades.push(dato.valor)
      extra.push(dato.Series)
    }
    this.data2.push({
      name: 'a',
      data: cantidades,
      extra: extra
    }) 
    this.titOrig2 = this.titulo2;
  }
  private obtDataGraf3(){
    this.subTitulo3 = this.cadenaEvaluacion[this.cadenaEvaluacion.length-1].evaluacion;
    const id = this.cadenaEvaluacion[this.cadenaEvaluacion.length-1].id;
    var aux = [], i = 0, pos = 0;
    for(const dat of this.dataOrdenadoBalance){
      if(i===2 && dat.Nivel === 1){
        this.titulo3 = dat.Descripcion;
        aux = this.obtDataSubnivel(dat, this.dataOrdenadoBalance, pos, id);
        i++;
      }else if(dat.Nivel===1){
        i++
      }
      pos++;
    }
    this.data3 = [];
    this.etiquetas3 = [];
    var cantidades = [], extra = [];
    for(const dato of aux){
      this.etiquetas3.push(dato.descripcion);
      cantidades.push(dato.valor)
      extra.push(dato.Series)
    }
    this.data3.push({
      name: 'a',
      data: cantidades,
      extra: extra
    }) 
    this.titOrig3 = this.titulo3;
  }
  /* click graficas */
  public selectGraf1(data){
    const base = this.data1[0].extra[data.posValue];
    if(base.length !== 0){
      this.data1 = [];
      this.etiquetas1 = [];
      var cantidades = [], extra = [];
      for(const dato of base){
        this.etiquetas1.push(dato.descripcion);
        cantidades.push(dato.valor)
        extra.push(dato.Series)
      }
      this.data1.push({
        name: 'a',
        data: cantidades,
        extra: extra
      });
      this.filtroAct1 = true;
    }else{
      messages.infoMessageGraph(this.translate.instant('financiero.catalogoCuentas.swal1'));
    }
  }
  public borrarFiltros1(){
    this.titulo1 = this.titOrig1;
    this.obtDataGraf1();
    this.filtroAct1 = false;
  }
  public selectGraf2(data){
    const base = this.data2[0].extra[data.posValue];
    if(base.length !== 0){
      this.data2 = [];
      this.data2 = [];
      this.etiquetas2 = [];
      var cantidades = [], extra = [];
      for(const dato of base){
        this.etiquetas2.push(dato.descripcion);
        cantidades.push(dato.valor)
        extra.push(dato.Series)
      }
      this.data2.push({
        name: 'a',
        data: cantidades,
        extra: extra
      });
      this.filtroAct2 = true;
    }else{
      messages.infoMessageGraph(this.translate.instant('financiero.catalogoCuentas.swal1'));
    }
  }
  public borrarFiltros2(){
    this.titulo2 = this.titOrig2;
    this.obtDataGraf2();
    this.filtroAct2 = false;
  }
  public selectGraf3(data){
    const base = this.data3[0].extra[data.posValue];
    if(base.length !== 0){
      this.data3 = [];
      this.data3 = [];
      this.etiquetas3 = [];
      var cantidades = [], extra = [];
      for(const dato of base){
        this.etiquetas3.push(dato.descripcion);
        cantidades.push(dato.valor)
        extra.push(dato.Series)
      }
      this.data3.push({
        name: 'a',
        data: cantidades,
        extra: extra
      });
      this.filtroAct3 = true;
    }else{
      messages.infoMessageGraph(this.translate.instant('financiero.catalogoCuentas.swal1'));
    }
  }
  public borrarFiltros3(){
    this.titulo3 = this.titOrig3;
    this.obtDataGraf3();
    this.filtroAct3 = false;
  }
  /* Ordenamiento */
  private ordenarArreglos(){
    this.dataOrdenadoBalance.sort(function (a, b) {
      if (a.posicion > b.posicion) {
        return 1;
      }
      if (a.posicion < b.posicion) {
        return -1;
      }
      return 0;
    });
    this.dataOrdenadoEstados.sort(function (a, b) {
      if (a.posicion > b.posicion) {
        return 1;
      }
      if (a.posicion < b.posicion) {
        return -1;
      }
      return 0;
    });
  }
  private buscarFaltantes(){
    var plantilla = '';
    if(this.cuentaEntity.Id_Plantilla === 5){
      plantilla = 'idsCuentasP5'
    }else if(this.cuentaEntity.Id_Plantilla === 7){
      plantilla = 'idsCuentasP7'
    }else if(this.cuentaEntity.Id_Plantilla === 9){
      plantilla = 'idsCuentasP9'
    }else if(this.cuentaEntity.Id_Plantilla === 8){
      plantilla = 'idsCuentasP8'
    }else if(this.cuentaEntity.Id_Plantilla === 12){
      plantilla = 'idsCuentasP12'
    }else if(this.cuentaEntity.Id_Plantilla === 13){
      plantilla = 'idsCuentasP13'
    }
    var auxBal = [];
    const bal = ObtenerIds[plantilla]('', `bal${this.monedaSelec}`, true);
    Object.keys(bal).forEach( e =>{
      const ex = this.dataOrdenadoBalance.find(d => d.posicion === bal[e][0].pos);
      if(ex){
        auxBal.push(ex);
      }else{
        auxBal.push({
          "id": '',
          "codigo": '',
          "idCuenta": '',
          "Descripcion": bal[e][0].nombre,
          "posicion": bal[e][0].pos, 
          "Nivel": bal[e][0].nivel,
          "Check": bal[e][0].nivel===1||bal[e][0].nivel===2?true:false,
          "dbCheck": bal[e][0].nivel===1?true:false,
          "Series": new Array(this.dataOrdenadoBalance[0].Series).fill(''),
          "evaluacionHorizontal": new Array(this.dataOrdenadoBalance[0].evaluacionHorizontal).fill(''),
        })
      }
    });
    this.dataOrdenadoBalance = auxBal;
    var auxEst = [];
    const est = ObtenerIds[plantilla]('', `est${this.monedaSelec}`, true);
    Object.keys(est).forEach( e =>{
      const ex = this.dataOrdenadoEstados.find(d => d.posicion === est[e][0].pos);
      if(ex){
        auxEst.push(ex);
      }else{
        auxEst.push({
          "id": '',
          "codigo": '',
          "idCuenta": '',
          "Descripcion": est[e][0].nombre,
          "posicion": est[e][0].pos, 
          "Nivel": est[e][0].nivel,
          "Check": est[e][0].nivel===1||est[e][0].nivel===2?true:false,
          "dbCheck": est[e][0].nivel===1?true:false,
          "Series": new Array(this.dataOrdenadoEstados[0].Series).fill(''),
          "evaluacionHorizontal": new Array(this.dataOrdenadoEstados[0].evaluacionHorizontal).fill(''),
        })
      }
    });
    this.dataOrdenadoEstados = auxEst;
  }
  private ultimasEvaluaciones(){
    this.cadenaEvaluacion = [];
    this.subTitles = [];
    this.periodosSeleccionados = 0;
    var i=0, cadena = '';
    for(const an of this.Periodos){
      if(an.utilizable){
        for(const mes of an.series){
          if(mes.check){
            this.periodosSeleccionados++;
            this.cadenaEvaluacion.push({
              evaluacion: mes.periodo,
              id: mes.id,
              porcentaje: '%',
            });
            if(i===0){
              this.subTitles.push(mes.periodo);
              cadena = ''+mes.id;
            }else{
              this.subTitles.push(' | ')
              this.subTitles.push(mes.periodo);
              cadena += ','+mes.id;
            }
            i++;
          }
        }
      }
    }
    this.getDetalleEvaluacion();
  }
  /* Obtención de periodos */
  public cambioPeriodo(per){
    if( per.check || (!per.check && this.periodosSeleccionadosAct() < this.maxPeriodos ) ){
      per.check = !per.check;
      this.cadenaEvaluacion = [];
      this.subTitles = [];
      this.periodosSeleccionados = 0;
      var i=0, cadena = '';
      for(const an of this.Periodos){
        for(const mes of an.series){
          if(mes.check){
            this.periodosSeleccionados++;
            this.cadenaEvaluacion.push({
              evaluacion: mes.periodo,
              id: mes.id,
              porcentaje: '%',
            });
            if(i===0){
              this.subTitles.push(mes.periodo);
              cadena = ''+mes.id;
            }else{
              this.subTitles.push(' | ')
              this.subTitles.push(mes.periodo);
              cadena += ','+mes.id;
            }
            i++;
          }
        }
      }
      this.detalleCuentasEvaluacion.ArregloID_evaluacion = cadena;
      this.getDetalleEvaluacion();
    }else{
      document.getElementById("check_"+per.mes+""+per.anio)['checked'] = false;
      messages.infoMessageGraph('No se pueden seleccionar mas de '+this.maxPeriodos+' periodos');
    }
  }
  public cambioPerspectives(sel){
    for(const pers of this.perspectives){
      if(sel.name === pers.name){
        pers.check = !pers.check;
      }else{
        pers.check = false;
      }
    }

    switch(sel.name){
      case 'Horizontal':
        this.analisisHorizontalActivate();
      break;
      case 'Vertical':
        this.analisisVerticalActivate();
      break;
    }
  }
  private periodosSeleccionadosAct(){
    var sel = 0;
    for(const an of this.Periodos){
      for(const mes of an.series){
        if(mes.check){
          sel++;
        }
      }
    }
    return sel;
  }
  public cambioBalanceEstados(camb){
    switch(camb){
      case 'bal':
        this.tituloTabla = 'financiero.catalogoCuentas.tituloTabla1';
        this.balanceEstados = true;
        break;
      case 'est':
        this.balanceEstados = false;
        this.tituloTabla = 'financiero.catalogoCuentas.tituloTabla2';
        break;
    }
  }
  /* Cambios de graficas */
  public changeGrafic1(tipo){
    this.tipo1 = tipo
  }
  public changeGrafic2(tipo){
    this.tipo2 = tipo;
  }
  public changeGrafic3(tipo){
    this.tipo3 = tipo;
  }
  public changeGraficRes(tipo){
    this.tipo4 = tipo;
  }
  /* acciones en filtros */
  public numPerSelect(){
    var selecc = 0;
    for(const an of this.Periodos){
      for(const mes of an.series){
        if(mes.check){
          selecc++;
        }
      }
    }
    if(selecc > 1)
      return true;
    return false;
  }
  public analisisVerticalActivate(){
    this.analisisVertical = !this.analisisVertical;
    if(this.analisisVertical)
      this.analisisHorizontal = false;
  }
  public analisisHorizontalActivate(){
    var si = 0;
    for(const anios of this.Periodos){
      for(const mes of anios.series){
        if(mes.check == true){
          si++;
        }
      }
    }
    if( si >= 2 && si <= 4 ){
      this.analisisHorizontal = !this.analisisHorizontal;
      if(this.analisisHorizontal)
        this.analisisVertical = false;
    }else{
      messages.infoMessageGraph("Seleccione solo 4 meses");
      this.analisisHorizontal = false;
      document.getElementById("check_vertical")['checked'] = false;
    }
  }
  /* Pintado de la tabla */
  public fontRowBalance(Id, nivel){
    if(nivel === 1)
      return 'w3-elemento-titulo-tableBalance w3-encabezado-balance';

    return 'w3-elemento-tableBalance';
  }
  public searchSubNivelBalance(item, pos){
    var con = 0;
    for(var i = pos+1; i<this.dataOrdenadoBalance.length; i++){
      if(this.dataOrdenadoBalance[i].Nivel > item.Nivel){
        con++;
      }
      if(this.dataOrdenadoBalance[i].Nivel === item.Nivel || this.dataOrdenadoBalance[i].Nivel < item.Nivel){
        break;
      }
    }
    if(con !== 0)
      return true;
    return false;
  }
  public hideShowRowBalance(item, pos){
    item.dbCheck = !item.dbCheck;
    for(var i = pos+1; i<this.dataOrdenadoBalance.length; i++){
      if(item.dbCheck){
        if(this.dataOrdenadoBalance[i].Nivel === item.Nivel+1){
          this.dataOrdenadoBalance[i].Check = true;
        }
      }else{
        if(this.dataOrdenadoBalance[i].Nivel !== item.Nivel && this.dataOrdenadoBalance[i].Nivel > item.Nivel){
          this.dataOrdenadoBalance[i].Check = false;
          this.dataOrdenadoBalance[i].dbCheck = false;
        }
      }
      if(this.dataOrdenadoBalance[i].Nivel === item.Nivel || this.dataOrdenadoBalance[i].Nivel < item.Nivel){
        break;
      }
    }
  }
  public fontRowEstados(lengthId, nivel){
    if(nivel === 1)
      return 'w3-elemento-titulo-tableBalance w3-encabezado-balance';

    return 'w3-elemento-tableBalance';
  }
  public searchSubNivelEstados(item, pos){
    var con = 0;
    for(var i = pos+1; i<this.dataOrdenadoEstados.length; i++){
      if(this.dataOrdenadoEstados[i].Nivel > item.Nivel){
        con++;
      }
      if(this.dataOrdenadoEstados[i].Nivel === item.Nivel || this.dataOrdenadoEstados[i].Nivel < item.Nivel){
        break;
      }
    }
    if(con !== 0)
      return true;
    return false;
  }
  public hideShowRowEstados(item, pos){
    item.dbCheck = !item.dbCheck;
    for(var i = pos+1; i<this.dataOrdenadoEstados.length; i++){
      if(item.dbCheck){
        if(this.dataOrdenadoEstados[i].Nivel === item.Nivel+1){
          this.dataOrdenadoEstados[i].Check = true;
        }
      }else{
        if(this.dataOrdenadoEstados[i].Nivel !== item.Nivel && this.dataOrdenadoEstados[i].Nivel > item.Nivel){
          this.dataOrdenadoEstados[i].Check = false;
          this.dataOrdenadoEstados[i].dbCheck = false;
        }
      }
      if(this.dataOrdenadoEstados[i].Nivel === item.Nivel || this.dataOrdenadoEstados[i].Nivel < item.Nivel){
        break;
      }
    }
  }
  public fontDatos(idcuenta, monto?){
    var len = 2;
    if(idcuenta === 1){
      return "w3-encabezado-balance";
    }else{
      if(monto < 0 ){
        return "w3-elemento-tableBalance";
      }else{
        return "w3-elemento-tableBalance";
      }
    }
  }
  /* formateo de datos */
  public formatingAxis(valor){
    return formatear.retornarformatolefty(valor);
  }
  public escrituraPer(Periodo){
    if(Periodo.split(' ').length === 2){
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.'+datos[0])+' '+datos[1];
    }else if(Periodo.split(' ').length === 5){
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.'+datos[0])+' '+datos[1]+' '+datos[2]+' '+this.translate.instant('filtros.'+datos[3])+' '+datos[4];
    }
    return Periodo;
  }
  /* Modales */
  public openModal(modal){
    this.graf1 = false;
    this.graf2 = false;
    this.graf3 = false;
    this.graf4 = false;
    switch(modal){
      case 'graf1': this.graf1 = true; break;
      case 'graf2': this.graf2 = true; break;
      case 'graf3': this.graf3 = true; break;
      case 'graf4': this.graf4 = true; break;
    }
    this.modalOpen = true;
  }
  /* exportacion */
  public exportExcel(){
    let headers = [this.translate.instant('financiero.catalogoCuentas.encabezado1Tabla1'), this.translate.instant('financiero.catalogoCuentas.encabezado2Tabla1')];
    for(const mes of this.cadenaEvaluacion){
      headers.push(this.escrituraPer(mes.evaluacion));
    }
    let datos = [], aux = [], niveles = [];
    for(const item of this.dataOrdenadoBalance){
      niveles.push(item.Nivel);
      aux.push(item.id);
      aux.push(item.Descripcion);
      for(const val of item.Series){
        aux.push(val.valor);
      }
      datos.push(aux);
      aux = [];
    }
    let titulo = this.translate.instant(this.tituloTabla)+' | ';
    for(const per of this.subTitles){
      titulo += this.escrituraPer(per)
    }
    this.excelService.generateEstadosFinancieros(titulo, headers, datos, this.translate.instant(this.tituloTabla)+' '+ this.escrituraPer(this.subTitles[this.subTitles.length-1]), niveles);
  }
  public exportExcelV(){
    let headers = [this.translate.instant('financiero.catalogoCuentas.encabezado1Tabla1'), this.translate.instant('financiero.catalogoCuentas.encabezado2Tabla1')];
    for(const mes of this.cadenaEvaluacion){
      headers.push(this.escrituraPer(mes.evaluacion));
      headers.push('%');
    }
    let datos = [], aux = [], niveles = [], i = 0, j = 0;
    for(const item of this.dataOrdenadoBalance){
      niveles.push(item.Nivel);
      aux.push(item?.codigo ?? item.idCuenta);
      aux.push(item.Descripcion);
      for(const val of item.Series){
        aux.push(val.valor);
        aux.push(Number(this.porcentajeEvaluacionVertical(this.dataOrdenadoBalance,val.valor,j,i).toFixed(0))/100);
        j++;
      }
      datos.push(aux);
      aux = [];
      j=0;
      i++;
    }
    let titulo = this.translate.instant(this.tituloTabla)+' | ';
    for(const per of this.subTitles){
      titulo += this.escrituraPer(per)
    }
    this.excelService.generateEstadosFinancierosV(titulo, headers, datos, this.translate.instant(this.tituloTabla)+' '+ this.escrituraPer(this.subTitles[this.subTitles.length-1]), niveles);
  }
  public exportExcelH(){
    let headers = [this.translate.instant('financiero.catalogoCuentas.encabezado1Tabla1'), this.translate.instant('financiero.catalogoCuentas.encabezado2Tabla1')];
    let headers2 = ['', ''];
    for(const mes of this.cadenaEvaluacion){
      headers.push(this.escrituraPer(mes.evaluacion));
      headers2.push('');
    }
    for(const n of this.cadenaEvaluacionHorizontal){
      headers.push('Variación');
      headers.push('%');
      headers2.push(this.escrituraPer(n.evaten));
      headers2.push('');
    }
    let datos = [], aux = [], niveles = [];
    for(const item of this.dataOrdenadoBalance){
      niveles.push(item.Nivel);
      aux.push(item?.codigo ?? item.idCuenta);
      aux.push(item.Descripcion);
      for(const val of item.Series){
        aux.push(val.valor);
      }
      for(const eva of item.evaluacionHorizontal){
        aux.push(Number(eva.evaluacionHorizontal.toFixed(0)));
        aux.push(Number(eva.porcentajeValorH.toFixed(0))/100);
      }
      datos.push(aux);
      aux = [];
    }
    let titulo = this.translate.instant(this.tituloTabla)+' | ';
    for(const per of this.subTitles){
      titulo += this.escrituraPer(per)
    }
    this.excelService.generateEstadosFinancierosH(titulo, headers, datos, this.translate.instant(this.tituloTabla)+' '+ this.escrituraPer(this.subTitles[this.subTitles.length-1]), niveles, headers2);
  }
  public exportExcel2(){
    let headers = [this.translate.instant('financiero.catalogoCuentas.encabezado1Tabla1'), this.translate.instant('financiero.catalogoCuentas.encabezado2Tabla1')];
    for(const mes of this.cadenaEvaluacion){
      headers.push(this.escrituraPer(mes.evaluacion));
    }
    let datos = [], aux = [], niveles = [];
    for(const item of this.dataOrdenadoEstados){
      niveles.push(item.Nivel);
      aux.push(item?.codigo ?? item.idCuenta);
      aux.push(item.Descripcion);
      for(const val of item.Series){
        aux.push(val.valor);
      }
      datos.push(aux);
      aux = [];
    }
    let titulo = this.translate.instant(this.tituloTabla)+' | ';
    for(const per of this.subTitles){
      titulo += this.escrituraPer(per)
    }
    this.excelService.generateEstadosFinancieros(titulo, headers, datos, this.translate.instant(this.tituloTabla)+' '+ this.escrituraPer(this.subTitles[this.subTitles.length-1]), niveles);
  }
  public exportExcelV2(){
    let headers = [this.translate.instant('financiero.catalogoCuentas.encabezado1Tabla1'), this.translate.instant('financiero.catalogoCuentas.encabezado2Tabla1')];
    for(const mes of this.cadenaEvaluacion){
      headers.push(this.escrituraPer(mes.evaluacion));
      headers.push('%');
    }
    let datos = [], aux = [], niveles = [], j= 0, i = 0;
    for(const item of this.dataOrdenadoEstados){
      niveles.push(item.Nivel);
      aux.push(item?.codigo ?? item.idCuenta);
      aux.push(item.Descripcion);
      for(const val of item.Series){
        aux.push(val.valor);
        aux.push(Number(this.porcentajeEvaluacionVertical(this.dataOrdenadoEstados,val.valor,j, i).toFixed(0))/100)
        j++;
      }
      datos.push(aux);
      aux = [];
      j=0;
      i++;
    }
    let titulo = this.translate.instant(this.tituloTabla)+' | ';
    for(const per of this.subTitles){
      titulo += this.escrituraPer(per)
    }
    this.excelService.generateEstadosFinancierosV(titulo, headers, datos, this.translate.instant(this.tituloTabla)+' '+ this.escrituraPer(this.subTitles[this.subTitles.length-1]), niveles);
  }
  public exportExcelH2(){
    let headers = [this.translate.instant('financiero.catalogoCuentas.encabezado1Tabla1'), this.translate.instant('financiero.catalogoCuentas.encabezado2Tabla1')];
    let headers2 = ['', ''];
    for(const mes of this.cadenaEvaluacion){
      headers.push(this.escrituraPer(mes.evaluacion));
      headers2.push('');
    }
    for(const n of this.cadenaEvaluacionHorizontal){
      headers.push('Variación');
      headers.push('%');
      headers2.push(this.escrituraPer(n.evaten));
      headers2.push('');
    }
    let datos = [], aux = [], niveles = [];
    for(const item of this.dataOrdenadoEstados){
      niveles.push(item.Nivel);
      aux.push(item?.codigo ?? item.idCuenta);
      aux.push(item.Descripcion);
      for(const val of item.Series){
        aux.push(val.valor);
      }
      for(const eva of item.evaluacionHorizontal){
        aux.push(Number(eva.evaluacionHorizontal.toFixed(0)));
        aux.push(Number(eva.porcentajeValorH.toFixed(0))/100);
      }
      datos.push(aux);
      aux = [];
    }
    let titulo = this.translate.instant(this.tituloTabla)+' | ';
    for(const per of this.subTitles){
      titulo += this.escrituraPer(per)
    }
    this.excelService.generateEstadosFinancierosH(titulo, headers, datos, this.translate.instant(this.tituloTabla)+' '+ this.escrituraPer(this.subTitles[this.subTitles.length-1]), niveles, headers2);
  }
  /**
   * @param id : numero de la zona donde se encuentra la grafica 
   * @param name: nombre que aparece en la imagen (titulo)
   */
  public exportIMG(id: number, name){
    var datosimg = { 
      titulo: this.translate.instant('menu.'+this.dataService.subModuleSelect),
      subtitulo: name,
      nombreArch: this.translate.instant('menu.'+this.dataService.subModuleSelect)
    }
    
    const comp = this.graficador.find(g => g.zona === id);
    comp.exportImg(id,datosimg);
    IMG.exportimagenes(id,name);
  }

  public capitalizacionTexto(text){
    if(!text) return;
    var mayuscula = text.substring(0,1).toUpperCase();
    if (text.length > 0) {
      var minuscula = text.substring(1).toLowerCase();
      if(minuscula[minuscula.length-1] === '.'){
        minuscula = minuscula.substring(0,minuscula.length-1);
      }
    }
    const textF = mayuscula.concat(minuscula);
    return textF;
  }
  public cambiarMoneda(moneda){
    this.monedaSelec = moneda;
    this.obtDataOrdenado(this.dataSaldos, this.dataCuentas);
  }
  public quitarFiltros(){
    this.balanceEstados = true;
    this.monedaSelec = '';
    this.analisisHorizontal = false;
    this.analisisVertical = false;
    this.Periodos = this.PeriodosOri;
    this.getDetalleEvaluacion();
  }
}
